<template>
  <b-modal
      :visible="visible"
      ref="modal"
      id="admin-category-type-edit-modal"
      title="Edit Category Type"
      @hidden="$emit('cancel')"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Category Type Name">
        <b-form-input
            v-model.trim="formData.name"
            type="text"
            :state="fieldValid('name')"
        />
        <b-form-invalid-feedback :state="fieldValid('name')">
          {{ formValidation.name }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Production Method">
        <b-form-checkbox
            v-model="formData.is_grow"
            :value="true"
            :unchecked-value="false"
        >
          <strong>Grow</strong> production method
        </b-form-checkbox>
        <b-form-checkbox
            v-model="formData.is_manufacture"
            :value="true"
            :unchecked-value="false"
        >
          <strong>Manufacture</strong> production method
        </b-form-checkbox>
      </b-form-group>
      <hr>
      <div class="d-flex align-items-center justify-content-between">
        <strong>METRC matching categories</strong>
        <b-button variant="success" @click="addNewMetrcCategory">
          <b-icon-plus/>
        </b-button>
      </div>
      <b-form-group
        v-for="(categoryName, index) in formData.metrc_categories"
        :key="index"
        label="METRC Category"
      >
<!--        <b-input-group>-->
<!--          <b-form-select-->
<!--            v-model.trim="formData.metrc_categories[index]"-->
<!--            :options="allMetrcCategoryTypes"-->
<!--            type="text"-->
<!--            :state="fieldValid(`metrc_categories.${index}`)"-->
<!--          />-->
<!--          <b-input-group-append>-->
<!--            <b-button variant="danger" @click="() => removeMetrCategory(index)">-->
<!--              <b-icon-x/>-->
<!--            </b-button>-->
<!--          </b-input-group-append>-->
<!--        </b-input-group>-->
        <b-input-group>
          <b-form-select
            v-model.trim="formData.metrc_categories[index]"
            :options="allMetrcCategories"
            type="text"
            :state="fieldValid(`metrc_categories.${index}`)"
          />
          <b-input-group-append>
            <b-button variant="danger" @click="() => removeMetrCategory(index)">
              <b-icon-x/>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <b-form-invalid-feedback :state="fieldValid(`metrc_categories.${index}`)">
          {{ formValidation[`metrc_categories.${index}`] }}
        </b-form-invalid-feedback>
      </b-form-group>
      <hr>
      <b-button type="submit" variant="success" :disabled="formState.processing">
        Submit
        <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminCategoryTypeEditModal",
  emits: ['success', 'cancel'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    categoryType: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      formData: {
        name: this.categoryType.name,
        is_grow: this.categoryType.is_grow,
        is_manufacture: this.categoryType.is_manufacture,
        metrc_categories: this.categoryType.metrc_categories
      },
      formValidation: {},
      formState: {
        processing: false
      },
      // allMetrcCategoryTypes: ['Buds', 'Concentrate', 'InfusedEdible', 'ShakeTrim', 'Plants', 'Other'],
      allMetrcCategories: [
        {
          label: 'Buds',
          options: ['Bud allocated for extraction', 'Buds']
        },
        {
          label: 'Concentrate',
          options: ['Concentrate', 'Concentrate (Each)']
        },
        {
          label: 'InfusedEdible',
          options: ['Infused (edible)', 'Infused (non-edible)']
        },
        {
          label: 'Plants',
          options: ['Genetic Material', 'Immature Plants', 'Seeds', 'Wet Whole Plants']
        },
        {
          label : 'ShakeTrim',
          options: ['Shake/Trim', 'Shake/Trim (by strain)', 'Shake/Trim allocated for extraction']
        },
        {
          label: 'Other',
          options: ['IHP- Extract/Concentrate', 'IHP- Oral Consumption', 'IHP- Suppository', 'IHP- Topical/Transdermal', 'IHP- Vaporizer/Cartridge', 'Metered Dose Inhaler', 'Vaporizer/Cartridge']
        },
      ]
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-category-type-edit-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-category-type-edit-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    addNewMetrcCategory() {
      this.formData.metrc_categories = [...this.formData.metrc_categories, ''];
    },
    removeMetrCategory(index) {
      this.formData.metrc_categories.splice(index, 1);
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(`${API_ROUTES.ADMIN_TAXONOMY_CATEGORY_TYPES}/${this.categoryType.id}`, this.formData).then(({data}) => {
        this.formValidation = {};
        this.$emit('success', data.category_type);
        this.close();
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to create a new category type', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            let error = data.errors[fieldName].join(', ');
            if (fieldName.indexOf('metrc_categories.') === 0) {
              error = error.replace(fieldName, '');
            }
            validationErrors[fieldName] = error;
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
